@if (actionGridField.showSimple) {
    <div class="simple-actions">
        <h3 class="sec-head">
            <button type="button" class="filter"
                    [class.active]="simpleFilter === 'all'"
                    [class.primary-font-color]="simpleFilter === 'all'"
                    matTooltip="Show all actions"
                    (click)="toggleFilter('all')">Actions</button>
            @if (total) { <span class="count">({{ total }})</span> }
            @if (todoCount) { <span class="sep">–</span> }
            @if (todoCount) {
                <button type="button" class="filter"
                        [class.active]="simpleFilter === 'todo'"
                        [class.primary-font-color]="simpleFilter === 'todo'"
                        (click)="toggleFilter('todo')">Todo ({{ todoCount }})</button>
            }
            <app-section-action-button label="Expand" icon="zoom_out_map"
                tip="Open the action list in a larger window"
                (act)="openBigList()"></app-section-action-button>
        </h3>

        <div class="rows-scroll">
            <table class="rows">
                @for (a of simpleActions; track a.id) {
                    <tr [class.done]="a.completedAt"
                        [matTooltip]="actionDescription(a)" matTooltipShowDelay="400">
                        <td class="tick">
                            @if (a.completedAt) {
                                <mat-icon color="primary"
                                    matTooltip="Completed {{ (a.completedAt * 1000) | date:'d MMM y' }}">check_box</mat-icon>
                            } @else if (!actionGridField.readonly) {
                                <button type="button" class="plain-btn click"
                                    matTooltip="Click to mark this action complete"
                                    data-field-name="completedAtCheckbox"
                                    (click)="markSimpleComplete(a)">
                                    <mat-icon color="primary">check_box_outline_blank</mat-icon>
                                </button>
                            } @else {
                                <mat-icon>check_box_outline_blank</mat-icon>
                            }
                        </td>
                        <td class="title">
                            <button type="button" class="plain-btn title-btn primary-font-color click"
                                data-field-name="title" (click)="openAction(a)">{{ a.title }}</button>
                        </td>
                        <td class="date" [class.overdue]="isOverdue(a)">
                            @if (a.completedAt) {
                                <span matTooltip="Marked complete {{ (a.completedAt * 1000) | date:'d MMM y, HH:mm:ss' }}">{{
                                    (a.completedAt * 1000) | date:'d MMM y' }}</span>
                            } @else {
                                {{ a.plannedDate | date:'d MMM y' }}
                            }
                        </td>
                        <td class="owner">{{ a.ownedByName }}</td>
                    </tr>
                } @empty {
                    <tr><td colspan="4" class="empty">No actions to show</td></tr>
                }
            </table>
        </div>

        @if (actionGridField.allowAdd && actionGridField.allowSimpleAdd && !actionGridField.readonly) {
            <div class="simple-add">
                <button type="button" class="link-add primary-font-color" data-grid-new="reminder"
                        matTooltip="Add a reminder to do something in the future"
                        (click)="addSimpleAction('future')">
                    <mat-icon>add</mat-icon>Add reminder
                </button>
                <button type="button" class="link-add primary-font-color" data-grid-new="action"
                        matTooltip="Log an action that has already been completed"
                        (click)="addSimpleAction('past')">
                    <mat-icon>check</mat-icon>Log completed
                </button>
            </div>
        }
    </div>
} @else {
    <app-grid [control]="control" [on]="on"></app-grid>
    @if (actionGridField.allowAdd && !actionGridField.readonly) {
        <div class="grid-add">
            <button type="button" mat-raised-button color="primary" data-grid-new="reminder"
                    matTooltip="Add a reminder to do something in the future"
                    (click)="addGridAction('future')">Add reminder</button>
            <button type="button" mat-raised-button color="primary" data-grid-new="action"
                    matTooltip="Log an action that has already been completed"
                    (click)="addGridAction('past')">Log completed</button>
        </div>
    }
}
